// extracted by mini-css-extract-plugin
export default {"root":"SectionHero_root__zeQDy","landingSearchForm":"SectionHero_landingSearchForm__-WjD4"};